import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox } from '../../../../components/Box';
import {
  BTW_COUNTRIES,
  CREATE_REQUIRED_FIELDS_TYPE_COMPANY,
  CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL,
  LANGUAGES
} from '../../constants';
import { setNewCompanyValue } from '../../actions';
import { selectCountries, selectHomeCompany, selectNewCompany } from '../../selectors';
import { Loader } from '../../../../components/Loader';
import Select from 'react-select';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { SearchCompanyAndUser } from '../../../Users/components/SearchCompanyAndUserComponent';
import { parseUser } from '../../../Users/helpers';
import { fetchUser, fetchUsersList } from '../../../Users/actions';
import { selectUsers } from '../../../Users/selectors';
import { Search } from '../../../../components/Icon';
import { Cell } from '../../../../components/List';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_USER } from '../../../Users/constants';
import { getPropByName } from '../../../../utils/props';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
// import { UserQuickCreator } from '../../../Users/pages/QuickCreate/QuickCreator';
import { UserQuickCreator } from '../../../Users/pages/QuickCreate';
import { parseAddressToCompanyValues } from '../../helpers';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './QuickCreatorModalComponent.module.css';
import PlaceAutocomplete from '../../components/AddressForm';
import { translateCountry } from '../../translate-countries';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

const Container = styled.div`
  width: 100%;

  .field-block {
    white-space: nowrap;
    margin-bottom: 8px;
    .label {
      width: 60%;
    }
    .user-selection-label {
      width: 60%;
    }
  }

  .radio-label {
    margin: 0 10px;
    font-size: 14px;
  }

  .rounded {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  .search-select {
    min-width: 300px;
    max-width: 300px;
  }

  .user-select {
    min-width: 250px;
    max-width: 250px;
  }

  .icon-button {
    margin: 0 10px;
  }

  .row-inputs-block {
    .col-1 {
      flex-basis: 20%;
    }
    .col-2 {
      flex-basis: 75%;
    }
  }
  .dropdown-BTW {
    > .Dropdown-root {
      min-width: 50px;
      max-width: 50px;

      > .Dropdown-menu {
        min-width: 130px;
      }
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 12px;
  color: red;
`;

const DropdownOptions = styled.ul`
  display: block;
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  border-radius: 0.375rem;
  top: 40px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '0' : '0')};
  background-color: white;
  max-height: 100px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#86b6fe3b' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'black' : 'inherited')};

  &:hover {
    background-color: #86b6fe3b;
    color: black;
  }
`;

const STATE = {
  string: null,
  result: null,
  // showUserQuickCreator: false,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyQuickCreatorModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      formData: {}, // Add state to hold form data
    });
  }

  componentDidMount() {
    this.props.setValue('company', 'company_type');
    this.props.setValue('NL', 'language');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.values?.contact && prevProps.values?.contact != this.props.values?.contact) {
      const isAddedUser = this.state.result?.find(u => u.id == this.props.values?.contact);
      if (!isAddedUser) {
        // this.props.fetchNewUser(this.props.values?.contact, result => this.setState({ result: [parseUser(result)] }));
      }
    }
  }

  get filterCompanyId() {
    return this.props.filter?.companyId;
  }

  get btwNumberInputValue() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    if (isWithCode) {
      return this.props.values?.BTW_number?.substring(2) || '';
    }
    return this.props.values?.BTW_number;
  }

  get locale() {
    return this.props.locale;
  }

  onBtwNumberChange(evt, property) {
    {
      let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
      const isWithCode = options.find(o => this.props.values[property]?.includes(o.value));

      if (isWithCode?.value) {
        this.props.setValue(`${isWithCode?.value}${evt.target.value}`, property);
        return;
      }

      this.props.setValue(evt.target.value, property);
    }
  }

  onStringChange(evt) {
    let string = evt.target?.value;
    evt && this.setState({ string });
  }

  onSearch() {
    this.search();
  }

  handleFormDataUpdate = newFormData => {
    const dto = parseAddressToCompanyValues(newFormData, this.props.countries);
    Object.keys(dto).forEach(key => {
      this.props.setValue(dto[key], key);
    });
    this.setState({ formData: newFormData });
  };

  search() {
    const search = this.state.string?.toLowerCase();
    this.props.fetchUsers(0, undefined, search, this.filterCompanyId, result =>
      this.setState({
        result: result.items?.map(parseUser).filter(user => user.id !== this.props.user?.id),
      }),
    );
  }

  radioButtons(property) {
    return (
      <div className={styles.checkboxContainer}>
        <CheckboxComponent
          onChange={pair => {
            this.props.setValue('individual', 'company_type');
            this.props.setValue('', 'contact');
            this.props.setValue('', 'company_email');
          }}
          checked={this.props.values?.company_type == 'individual'}
          label={this.lbl('company.property.company_type.individual')}
        />

        <CheckboxComponent
          onChange={pair => {
            this.props.setValue('company', 'company_type');
            this.props.setValue('', 'surname');
            this.props.setValue('', 'country_code');
            this.props.setValue('', 'phone_number');
            this.props.setValue('', 'email');
          }}
          checked={this.props.values?.company_type == 'company'}
          label={this.lbl('company.property.company_type.company')}
        />
      </div>
    );
  }

  btwDropdown(property) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.props.values[property]?.includes(o.value));

    return (
      <div className={'dropdown-BTW'}>
        <Dropdown
          options={options}
          value={value?.value ? value?.value + ' ' : ''}
          onChange={pair => {
            if (value?.value) {
              this.props.setValue(`${pair.value}${this.props.values?.BTW_number?.substring(2) || ''}`, 'BTW_number');
              return;
            }
            return this.props.setValue(`${pair.value}${this.props.values?.BTW_number || ''}`, 'BTW_number');
          }}
        />
      </div>
    );
  }

  searchSelect() {
    const options = this.props.countries?.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    const value = options.find(o => o.value == this.props.values?.countryId);
    return (
      <SearchSelect
        options={options}
        value={value}
        onChange={evt => this.props.setValue(evt.value, 'countryId')}
        className="filter"
      />
    );
  }

  userSelection() {
    if (this.props.workUser) return <Loader small />;

    const options = this.state.result?.map(user => ({
      value: user.id,
      label: `${user.name || ''} ${user.surname || ''} ${user.email_address || ''}`,
    }));
    const value = options?.find(o => o.value == this.props.values?.contact);
    return (
      <div className={styles.container}>
        <div className={styles.flexContainer}>
          <input
            className="form-control"
            name="string"
            onChange={this.onStringChange.bind(this)}
            value={value?.label}
            placeholder={this.lblStr('company.search.placeholder')}
          />
          {this.renderResult()}
          <div className={styles.button}>
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.search.bind(this)}>
              <Search />
            </ButtonComponent>
          </div>
        </div>
      </div>
    );
  }

  renderResult() {
    if (!this.state.result) return '';

    return (
      <DropdownOptions>
        {this.state.result?.map(user => {
          return (
            <DropdownOption
              key={user.id}
              onClick={() => {
                this.setState({ result: null }, () => {
                  this.props.setValue(user?.id, 'contact');
                });
              }}
            >
              <Cell>
                {user?.name}
                &nbsp;
                {user?.surname}
                &nbsp;
                {user.email_address}
              </Cell>
            </DropdownOption>
          );
        })}
      </DropdownOptions>
    );
  }

  renderDuplicateEmailNotification() {
    const { duplicateUser } = this.props;

    if (!duplicateUser?.length) return;

    const email = duplicateUser[0]?.email_address;
    const name = getPropByName(duplicateUser[0], 'name');
    const surnaname = getPropByName(duplicateUser[0], 'surname');

    return (
      <div>
        <div>
          <label className="form-label">{`Email ${email} in use by ${name} ${surnaname}. Do you want to add this user for this company?`}</label>
          <div>
            <ButtonComponent
              size={'btn-sm'}
              style={'ButtonSoftPrimary'}
              disabled={this.applyDisabled()}
              onClick={() => this.props.onSave({ id: duplicateUser[0]?.id })}
            >
              {this.lbl('yes')}
            </ButtonComponent>
            <ButtonComponent
              style={'ButtonSoftDelete'}
              size={'btn-sm'}
              disabled={this.applyDisabled()}
              onClick={() => this.props.onSave('no')}
            >
              {this.lbl('no')}
            </ButtonComponent>
          </div>
        </div>
      </div>
    );
  }

  applyDisabled() {
    return (
      this.props.workCreate ||
      this.props.workUser ||
      //!this.props.values?.accountManagerId ||
      (this.props.values?.company_type == 'individual' && !this.props.values?.email)
    );
  }

  get requiredFields() {
    if (env.clientId !== AppClientId.AUTOWIENTJES) return [];
    const types =
      this.props.values.company_type === 'company'
        ? CREATE_REQUIRED_FIELDS_TYPE_COMPANY
        : CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL;

    return types.filter(type => !this.props.values[type]);
  }

  isWaiting() {
    return this.props.workCreate || this.props.workUser;
  }

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }
  // handleUserQuickCreatorToggle() {
  //   this.setState(prevState => ({ showUserQuickCreator: !prevState.showUserQuickCreator }));
  // }

  render() {
    return (
      <ModalComponent
        className={styles.modal}
        title={this.lbl('company.create.modal.title')}
        onClose={this.reset.bind(this)}
      >
        <PlaceAutocomplete onUpdate={this.handleFormDataUpdate} />
        {this.props.fields?.map(property => {
          if (property == 'company_type') {
            return (
              <div className={styles.inputContainer}>
                <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                <div>{this.radioButtons(property)}</div>
              </div>
            );
          }

          if (property == 'country_code') return;

          if (property == 'BTW_number') {
            return (
              this.props.values?.company_type == 'company' && (
                <div className={styles.inputContainer}>
                  <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                  <div>
                    <div style={{ width: '100px' }}>{this.btwDropdown(property)}</div>
                    <input
                      className="form-control"
                      value={this.btwNumberInputValue}
                      onChange={evt => this.onBtwNumberChange(evt, property)}
                      placeholder={this.lblStr(`company.property.${property}`)}
                    />
                  </div>
                </div>
              )
            );
          }

          if (property == 'countryId') {
            return (
              <>
                <div className={styles.inputContainer}>
                  <label className="form-label">
                    {this.lbl(`company.property.${property}`)} <RequireMark>*</RequireMark>
                  </label>
                  {this.searchSelect()}
                </div>
              </>
            );
          }

          if (property === 'language') {
            let options = LANGUAGES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
            let value = options.find(o => this.props.values[property]?.includes(o.value));

            return (
              <div className={styles.inputContainer}>
                <label className="form-label">
                  {this.lbl(`company.property.${property}`)} <RequireMark>*</RequireMark>
                </label>
                <div className={styles.dropdownContainer}>
                  <Dropdown
                    options={options}
                    value={value?.value ? `${value?.value}` : 'NL'}
                    onChange={pair => {
                      if (value?.value) {
                        this.props.setValue(`${pair.value}${this.props.values?.language?.substring(2) || ''}`, 'language');
                        return;
                      }
                      return this.props.setValue(`${pair.value}${this.props.values?.language || ''}`, 'language');
                    }}
                    className={styles.dropdown}
                    menuClassName={styles.dropdownMenu}
                  />
                </div>
              </div>
            );
          }

          if (property == 'accountManagerId') {
            return (
              <div className={styles.inputContainer}>
                <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                <div className={styles.wrapper}>
                  <SearchCompanyAndUser
                    homeCompanyId={this.props.homeCompanyId}
                    key={`${property}-${this.props.values[property]}`}
                    type={property}
                    value={this.props.values[property]}
                    onSelect={value => {
                      return this.props.setValue(value?.id, property);
                    }}
                    requiredFields={this.requiredFields}
                  />
                </div>
              </div>
            );
          }

          if (property == 'contact') {
            return (
              this.props.values?.company_type == 'company' && (
                <div className={styles.inputContainer}>
                  <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                  <div>
                    {this.userSelection()}

                    <div className="icon-button">
                      <ButtonComponent
                        style={'ButtonSoftPrimary'}
                        size={'btn-sm'}
                        onClick={() => this.props.onShowUserModal()}
                      >
                        {this.lbl('company.create.modal.new_contact')}
                      </ButtonComponent>
                    </div>
                  </div>

                  {/* {this.state.showUserQuickCreator && (
                    <UserQuickCreator
                    />
                  )} */}
                </div>
              )
            );
          }

          if (property == 'surname') {
            return (
              this.props.values?.company_type == 'individual' && (
                <>
                  <div className={styles.inputContainer}>
                    <label className="form-label">
                      {this.lbl(`company.property.${property}`)}
                      <RequireMark>*</RequireMark>
                    </label>
                    <input
                      className="form-control"
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      placeholder={this.lblStr(`company.property.${property}`)}
                    />
                  </div>
                </>
              )
            );
          }

          if (property == 'addressLine1') {
            return (
              <>
                <div className={styles.inputContainer}>
                  <label className="form-label">
                    {this.lbl(`company.property.${property}`)}
                    <RequireMark>*</RequireMark>
                  </label>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              </>
            );
          }

          if (property == 'name') {
            return (
              <>
                <div className={styles.inputContainer}>
                  <label className="form-label">
                    {this.lbl(`company.property.${property}`)}
                    <RequireMark>*</RequireMark>
                  </label>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              </>
            );
          }

          if (property == 'postcode') {
            return (
              <>
                <div className={styles.inputContainer}>
                  <label className="form-label">
                    {this.lbl(`company.property.${property}`)}
                    <RequireMark>*</RequireMark>
                  </label>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              </>
            );
          }

          if (property == 'city') {
            return (
              <>
                <div className={styles.inputContainer}>
                  <label className="form-label">
                    {this.lbl(`company.property.${property}`)}
                    <RequireMark>*</RequireMark>
                  </label>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              </>
            );
          }

          if (property == 'email') {
            return (
              this.props.values?.company_type == 'individual' && (
                <div className={styles.inputContainer}>
                  <label className="form-label">{this.lbl(`company.property.${property}`)}</label>{' '}
                  <RequireMark>*</RequireMark>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              )
            );
          }

          if (property == 'company_email') {
            return (
              this.props.values?.company_type == 'company' && (
                <div className={styles.inputContainer}>
                  <label className="form-label">{this.lbl(`company.property.${property}`)}</label>{' '}
                  <RequireMark>*</RequireMark>
                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              )
            );
          }
          if (property == 'phone_number') {
            return (
              this.props.values?.company_type == 'individual' && (
                <>
                  <div className={styles.inputContainer}>
                    <label className="form-label">
                      {this.lbl(`company.property.${property}`)}
                      <RequireMark>*</RequireMark>
                    </label>
                    <div className={styles.inputPhone}>
                      <input
                        className={cn('form-control', styles.inputCountryCode)}
                        value={this.props.values?.country_code}
                        onChange={evt => this.props.setValue(evt.target.value, 'country_code')}
                        placeholder="+"
                      />

                      <input
                        className="form-control"
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        placeholder="Number"
                      />
                    </div>
                  </div>
                </>
              )
            );
          }

          if (property == 'name') {
            return (
              <>
                <div>
                  <label className="form-label">{this.lbl(`company.property.${property}`)}</label>

                  <input
                    className="form-control"
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    placeholder={this.lblStr(`company.property.${property}`)}
                  />
                </div>
              </>
            );
          }

          if (property == 'surname') {
            return (
              this.props.values?.company_type == 'individual' && (
                <>
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                    <input
                      className="form-control"
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      placeholder={this.lblStr(`company.property.${property}`)}
                    />
                  </div>
                </>
              )
            );
          }
          if (property == 'phone_number') {
            return (
              this.props.values?.company_type == 'individual' && (
                <>
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl(`company.property.${property}`)}</label>

                    <div className={styles.inputPhone}>
                      <input
                        className="form-control"
                        value={this.props.values?.country_code}
                        onChange={evt => this.props.setValue(evt.target.value, 'country_code')}
                        placeholder="+"
                      />

                      <input
                        className="form-control"
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        placeholder="Number"
                      />
                    </div>
                  </div>
                </>
              )
            );
          }
          return (
            <>
              <div className={styles.inputContainer}>
                <label className="form-label">{this.lbl(`company.property.${property}`)}</label>
                <input
                  className="form-control"
                  value={this.props.values[property]}
                  onChange={evt => this.props.setValue(evt.target.value, property)}
                  placeholder={this.lblStr(`company.property.${property}`)}
                />
              </div>
            </>
          );
        })}

        {this.isWaiting() ? (
          <HBox center>
            <strong>{this.lbl('please_wait')}</strong>
          </HBox>
        ) : (
          ''
        )}
        {this.renderDuplicateEmailNotification()}

        <div className={styles.buttonGroup}>
          <ButtonComponent style={'ButtonSoftDelete'} disabled={this.props.workCreate} onClick={this.reset.bind(this)}>
            {this.lbl(`cancel`)}
          </ButtonComponent>

          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.requiredFields.length || this.props.duplicateUser?.length}
            select={this.isWaiting() || this.props.duplicateUser?.length}
            primary={!this.isWaiting()}
            onClick={this.save.bind(this)}
          >
            {this.lbl(`confirm`)}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewCompany(),
    countries: selectCountries(),
    users: selectUsers(),
    homeCompanyId: selectHomeCompany(),
    workUser: selectWork(`${REQUEST_USER}`),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
    fetchUsers: (offset, limit, string, companyId, callback) => {
      dispatch(fetchUsersList(offset, limit, string, companyId, callback));
    },
    fetchNewUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyQuickCreatorModal = compose(withConnect, withRouter, injectIntl)(CompanyQuickCreatorModalComp);
